import { Validator } from "../Validator";

export class Mobile extends Validator {
    public validate(value: any, opt: any): boolean {
        return /^1[\d]{10}$/.test(value);
    }
}
